import React from 'react';
import { Link } from 'react-router-dom';
import { Einwohnermeldeamt } from '../../types/einwohnermeldeamt';
import { formatNumber, getCleanLocationName } from '../../utils/einwohnermeldeamtHelpers';

interface LocationCardProps {
  location: Einwohnermeldeamt;
}

const LocationCard: React.FC<LocationCardProps> = ({ location }) => {
  return (
    <Link
      to={`/einwohnermeldeamt/${location.bundeslandSlug}/${location.slug}`}
      className="block bg-white rounded-lg p-5 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 group"
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h3 className="text-lg font-bold mb-1 group-hover:text-celestial-blue transition-colors" style={{ color: '#023047' }}>
            {getCleanLocationName(location.gemeindeName)}
          </h3>
          {location.kreis && <p className="text-sm text-gray-600">{location.kreis}</p>}
        </div>
        <svg
          className="w-5 h-5 text-gray-400 group-hover:translate-x-1 transition-transform flex-shrink-0 ml-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </div>
      
      <div className="space-y-1 text-sm text-gray-600">
        {location.postleitzahl && (
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
            </svg>
            <span>PLZ: {location.postleitzahl}</span>
          </div>
        )}
        
        {location.einwohner !== undefined && (
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
            </svg>
            <span>{formatNumber(location.einwohner)} Einwohner</span>
          </div>
        )}
        
        {location.strasse && (
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
            </svg>
            <span className="truncate">{location.strasse}</span>
          </div>
        )}
      </div>
    </Link>
  );
};

export default LocationCard;

